import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import dismissRfqUpdates from "@insite/client-framework/Store/Context/Handlers/DismissRfqUpdates";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link";
import Page from "@insite/mobius/Page";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import React, { useEffect } from "react";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    getSelectedProductPath,
    getSession,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { headerShipToAddressStyles } from "@insite/content-library/Widgets/Common/HeaderShipToAddress";
import { headerLinkListStyles } from "@insite/content-library/Widgets/Header/HeaderLinkList";
import mainNavigation, { mainNavigationStyles } from "@insite/content-library/Widgets/Header/MainNavigation";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import LazyImage from "@insite/mobius/LazyImage";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { AdminCustomSettings } from "@tCooneyBrothers/ApiModels";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
// import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    siteName: state.context.website.name,
    session: getSession(state),
    myAccountPageUrl: getPageLinkByPageType(state, "MyAccountPage")?.url,
    adminCustomSettings: getSettingsCollection(state).adminCustomSettings as AdminCustomSettings,
    errorModal: state.context.isErrorModalOpen,
});

const mapDispatchToProps = {
    dismissRfqUpdates,
};

type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext &
    HasHistory;

export interface HeaderStyles {
    container?: InjectableCss;
    skipToContent?: SkipNavStyles;
    websiteName?: InjectableCss;
    wrapper?: InjectableCss;
    secondaryNavWrapper?: InjectableCss;
    headerWrapper?: InjectableCss;
    mobileNavWrapper?: InjectableCss;
    upgradeModal?: ModalPresentationProps;
    browserSupportDesc?: InjectableCss;
    supportGridItem?: GridItemProps;
}

headerShipToAddressStyles.shipToAddressWrapper = {
    css: css`
        display: none;
    `,
};
headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        text-align: right;
        padding: 0;
        margin-right: -9px;
    `,
};

logoStyles.wrapper = {
    css: css`
        max-width: 300px;
        max-height: 100px;
        min-height: 100%;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                        flex-grow: 1;
                    `,
                    null,
                    null,
                ],
                "max",
            );
        }}
    `,
};

mainNavigationStyles.container = {
    css: css`
        color: ${getColor("common.background")};
        padding: 0;
        display: block;
        justify-content: left;

        p[class^="TypographyStyle"] {
            color: #fff;
        }
    `,
};

mainNavigationStyles.itemWrapper = {
    css: css`
        position: relative;
        overflow: visible;
        display: flex;
        ul {
            width: 250px;
            ul {
                left: 250px !important;
            }
        }
        &:hover {
            span + div {
                display: block;
            }
            span,
            a {
                p {
                    color: #fff !important;
                    text-decoration: underline;
                    span {
                        color: #fff !important;
                    }
                }
            }
        }
        &:first-child {
            margin-left: -10px;
        }
    `,
};

mainNavigationStyles.menuItem = {
    css: css`
        display: flex;
        align-items: center;
        // height: 42px;
        // padding: 0 10px;

        &:hover {
            p,
            span {
                color: #fff !important;
                text-decoration: underline;
            }
        }
        & + ul {
            li a {
                min-height: auto;
                span {
                    font-size: 13px;
                    padding: 6px 10px 6px 10px;
                    line-height: 20px;
                    & + span {
                        padding: 0;
                        top: 4px;
                    }
                }
            }
        }
    `,
};

const styles: HeaderStyles = {
    container: {
        css: css`
            @font-face {
                font-family: "HelveticaCondensed";
                src: local("HelveticaCondensed"), local("HelveticaCondensed"),
                    url(/UserFiles/Fonts/helvetica-condensed-bold-webfont.woff2) format("woff2"),
                    url(/UserFiles/Fonts/helvetica-condensed-bold-webfont.woff) format("woff");
                font-weight: normal;
                font-style: normal;
            }
            display: flex;
            margin: 0 auto;
            max-width: 1440px;
            > div:first-child {
                flex-grow: 1;
                div[class^="HiddenStyle"] {
                    > div {
                        > div:nth-child(1n + 4) {
                            float: right;
                            nav {
                                padding-bottom: 10px;
                                > a {
                                    pointer-events: none;
                                    + ul[class^="MenuStyle"] {
                                        top: 29px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
    websiteName: {
        css: css`
            @media print {
                display: block;
            }
            font-size: 12px;
            padding-left: 15px;
            display: none;
        `,
    },
    headerWrapper: {
        css: css`
            position: sticky;
            top: 0px;
            z-index: 999;
            >div>div>div{
                position: sticky !important;
                top: 0px;
            }
            >div>div{
                position: sticky !important;
                border: none !important;
            }
            >div:first-of-type>div>div{
                z-index: 9999;
            }
                
            >div:first-of-type>div{
                z-index: 9999;
            }

            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                    >div>div>div{
                        position: initial !important;
                    }
                    >div>div{
                        position: initial !important;
                        border: none !important;
                    }
                    `,
                    null,
                    null
                ],"max",
            )}

            ~ main {
                min-height: 500px;
                &.productNotFound {
                    [data-test-selector="productListLeftCoulmn"],
                    [data-test-selector="productListFilter"] {
                        display: none;
                    }
                    [data-test-selector="plpFilterTextInfoHide"] {
                        display: none !important;
                    }
                    [class^="Wrapper"] {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        padding: 15px;
                                    `,
                                    css`
                                        padding: 15px;
                                    `,
                                ],
                                "max",
                            )}
                        [class^="GridWrapper"] {
                            [class^="GridOffset"] {
                                justify-content: center;
                                width: auto !important;
                            }
                        }
                    }
                }
            }
        `,
    },
    wrapper: {
        css: css`
            background-image: linear-gradient(-90deg, #453031, #ef3742);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            background-image: none;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    secondaryNavWrapper: {
        css: css`
            display: block;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: none;
                        `,
                    ],
                    "max",
                )}
            width: 55%;
            padding-right: 15px;
            div[class^="Wrapper"] div[class^="HiddenStyle"] > div {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-right: 0;
                height: auto;

                a {
                    p,
                    span {
                        text-transform: capitalize;
                    }
                }
                nav {
                    > a {
                        pointer-events: none;
                    }
                    a {
                        p {
                            text-transform: capitalize;
                        }
                        span {
                            color: #fff;
                            font-size: 13px;
                            padding: 0;
                            &:hover {
                                color: #fff;
                                text-decoration: underline;
                            }
                        }
                        &:last-child {
                            span {
                                padding-right: 0;
                            }
                        }
                    }
                    ul {
                        li {
                            a {
                                span {
                                    color: #353432;
                                    padding: 6px 10px;
                                }
                                &:hover {
                                    span {
                                        color: #353432;
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                max-width: 50px;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
    mobileNavWrapper: {
        css: css`
            display: none;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: flex;
                            [class^="HiddenStyle"] {
                                &:last-child {
                                    display: none;
                                }
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    browserSupportDesc: {
        css: css`
            text-align: center;
            width: 570px;
            margin: 0 auto;
            h2 {
                font-size: 36px;
                line-height: 40px;
                font-family: Helvetica, sans-serif;
            }
            p {
                font-size: 16px;
                line-height: 23px;
            }
            h6 {
                font-size: 17px;
                line-height: 24px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    supportGridItem: {
        width: [6, 6, 3, 3, 3],
        css: css`
            flex-direction: column;
            align-items: center;
            img {
                width: 125px;
            }
            [class^="StyledButton"] {
                span {
                    font-size: 16px;
                }

                ~ span {
                    font-size: 15px;
                    color: #797878;
                }
            }
        `,
    },
    upgradeModal: {
        cssOverrides: {
            modalBody: css`
                max-width: 700px !important;
                max-height: calc(100vh - 30px) !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                max-width: 100% !important;
                            `,
                            css`
                                max-width: 100% !important;
                            `,
                            css`
                                max-width: 100% !important;
                            `,
                        ],
                        "max",
                    )}
            `,
        },
    },
};
export const headerStyles = styles;

const Header = ({
    id,
    siteName,
    session,
    toaster,
    history,
    myAccountPageUrl,
    dismissRfqUpdates,
    adminCustomSettings,
    errorModal,
}: Props) => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const viewMyDashboardClickHandler = () => {
        if (myAccountPageUrl) {
            history.push(myAccountPageUrl);
        }
    };

    const mounted = useRef<boolean>(false);

    const splitVersion = (v: string) => {
        const version = v.split(" ")[0].split(".")[0];
        return version;
    };

    const modalCloseHandler = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        if (errorModal) {
            setTimeout(function () {
                const checkUnhandaledErrorPopup = document.querySelector<HTMLElement>(
                    '[data-test-selector="unhandledErrorModal"]',
                );
                if (checkUnhandaledErrorPopup) {
                    const modal = checkUnhandaledErrorPopup.closest<HTMLElement>('[class^="ContentBody"]');
                    if (modal) {
                        modal
                            .querySelector('[data-test-selector="modalCloseButton"]')
                            ?.addEventListener("click", function () {
                                window.location.reload();
                                window.scrollTo(0, 0);
                            });
                        if (window.innerWidth > 900) {
                            modal.style.maxWidth = "500px";
                        }
                    }
                }
            }, 0);
        }
    }, [errorModal]);

    useEffect(() => {
        const { userAgent } = navigator;
        let version;
        if (userAgent.includes("Firefox/")) {
            version = splitVersion(userAgent.split("Firefox/")[1]);
            if (version >= adminCustomSettings.browserSupportedVersion) {
                if (version >= adminCustomSettings.browserConstantVersion) {
                    setIsModalOpen(false);
                }
            } else if (version <= adminCustomSettings.firefoxBrowserNonSupportVersion) {
                setIsModalOpen(true);
            }
            // Firefox
        } else if (userAgent.includes("Edge/")) {
            version = splitVersion(userAgent.split("Edge/")[1]);
            if (version >= adminCustomSettings.browserSupportedVersion) {
                if (version >= adminCustomSettings.browserConstantVersion) {
                    setIsModalOpen(false);
                }
            } else if (version <= adminCustomSettings.edgeBrowserNonSupportVersion) {
                setIsModalOpen(true);
            }
            // Edge (Chromium)
        } else if (userAgent.includes("Chrome/")) {
            version = splitVersion(userAgent.split("Chrome/")[1]);
            if (version >= adminCustomSettings.browserSupportedVersion) {
                if (version >= adminCustomSettings.browserConstantVersion) {
                    setIsModalOpen(false);
                }
            } else if (version <= adminCustomSettings.chromeBrowserNonSupportVersion) {
                setIsModalOpen(true);
            }

            // Chrome
        } else if (userAgent.includes("IE/")) {
            version = splitVersion(userAgent.split("IE/")[1]);
            if (version >= adminCustomSettings.browserSupportedVersion) {
                if (version >= adminCustomSettings.browserConstantVersion) {
                    setIsModalOpen(false);
                }
            } else if (version <= adminCustomSettings.ieBrowserNonSupportVersion) {
                setIsModalOpen(true);
            }
            // IE
        } else if (userAgent.includes("Safari/")) {
            if (userAgent.includes("Version/")) {
                version = splitVersion(userAgent.split("Version/")[1]);
                if (version >= adminCustomSettings.browserSupportedVersion) {
                    if (version >= adminCustomSettings.browserConstantVersion) {
                        setIsModalOpen(false);
                    }
                } else if (version <= adminCustomSettings.safariBrowserNonSupportVersion) {
                    setIsModalOpen(true);
                }
            } else if (userAgent.includes("CriOS/")) {
                version = splitVersion(userAgent.split("CriOS/")[1]);
                if (version >= adminCustomSettings.browserSupportedVersion) {
                    if (version >= adminCustomSettings.browserConstantVersion) {
                        setIsModalOpen(false);
                    }
                } else if (version <= adminCustomSettings.chromeBrowserNonSupportVersion) {
                    setIsModalOpen(true);
                }
            }

            // Safari
        } else if (userAgent.includes("Opera/")) {
            version = splitVersion(userAgent.split("Opera/")[1]);
            if (version >= adminCustomSettings.browserSupportedVersion) {
                if (version >= adminCustomSettings.browserConstantVersion) {
                    setIsModalOpen(false);
                }
            } else if (version <= adminCustomSettings.operaBrowserNonSupportVersion) {
                setIsModalOpen(true);
            }
            // Opera
        }

        if (session.hasRfqUpdates && myAccountPageUrl) {
            toaster.addToast({
                body: (
                    <>
                        <Typography>{translate("You have new quote information.")}</Typography>
                        <Link onClick={viewMyDashboardClickHandler}>{translate("View My Dashboard")}</Link>
                    </>
                ),
                messageType: "info",
                timeoutLength: 1000 * 60 * 60 * 24 * 365,
                onClose: () => {
                    dismissRfqUpdates();
                },
            });
        }
    }, [myAccountPageUrl]);
    const afterHeader = React.createRef<HTMLSpanElement>();
    return (
        <>
            {siteName && <Typography {...styles.websiteName}>{siteName}</Typography>}
            <StyledWrapper style={{height:"auto"}}>
                <Zone contentId={id} zoneName="SecondaryNavigationBanner"/>
            </StyledWrapper>
            <Page as="header" fullWidth={[true, true, true, true, true]} isHeader={true} {...styles.headerWrapper}>
                <SkipNav
                    extendedStyles={styles.skipToContent}
                    text={translate("Skip to main content")}
                    destination={afterHeader}
                />
                <Zone contentId={id} zoneName="SecondaryNavigation" />
                <StyledWrapper {...styles.wrapper}>
                    <StyledWrapper {...styles.container}>
                        <Zone contentId={id} zoneName="MainNavigation" />
                        {/* <Hidden below="lg" {...styles.secondaryNavWrapper}>
                            <Zone contentId={id} zoneName="Cart" />
                        </Hidden> */}
                        {/* <Hidden above="md" {...styles.mobileNavWrapper}>
                            <Zone contentId={id} zoneName="MobileNav" />
                        </Hidden> */}
                    </StyledWrapper>
                </StyledWrapper>
                <Zone contentId={id} zoneName="Breadcrumb" />
                <span ref={afterHeader} tabIndex={-1} />
            </Page>
            <Modal
                headline={siteMessage("NonSupported_Browser_Heading")}
                contentLabel="Upgrade"
                isOpen={isModalOpen}
                handleClose={modalCloseHandler}
                {...styles.upgradeModal}
            >
                <StyledWrapper {...styles.browserSupportDesc}>
                    {siteMessage("NonSupported_Browser_Description")}
                </StyledWrapper>
                <GridContainer>
                    <GridItem {...styles.supportGridItem}>
                        <LazyImage src="/UserFiles/images/icons/chrome.png"></LazyImage>
                        <Link
                            href="https://www.google.com/chrome/?brand=JJTC&gclid=EAIaIQobChMIkfOFpfmd8QIVi38rCh1hSgnSEAAYASAAEgIb5PD_BwE&gclsrc=aw.ds"
                            target="_blank"
                        >
                            {translate("Google Chrome")}
                        </Link>
                        <Typography>version 68+</Typography>
                    </GridItem>
                    <GridItem {...styles.supportGridItem}>
                        <LazyImage src="/UserFiles/images/icons/edge.png"></LazyImage>
                        <Link href="https://www.microsoft.com/en-us/edge" target="_blank">
                            {translate("Microsoft Edge")}
                        </Link>
                        <Typography>version 80+</Typography>
                    </GridItem>
                    <GridItem {...styles.supportGridItem}>
                        <LazyImage src="/UserFiles/images/icons/firefox.png"></LazyImage>
                        <Link href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">
                            {translate("Mozilla Firefox")}
                        </Link>
                        <Typography>version 61+</Typography>
                    </GridItem>
                    <GridItem {...styles.supportGridItem}>
                        <LazyImage src="/UserFiles/images/icons/safari.png"></LazyImage>
                        <Link href="https://support.apple.com/downloads/safari" target="_blank">
                            {translate("Apple safari")}
                        </Link>
                        <Typography>version 12.1+</Typography>
                    </GridItem>
                </GridContainer>
            </Modal>
        </>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(Header))),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export const HeaderContext = "HeaderContext";

export default pageModule;
